import { Modal, useModalWrapperContext } from '../../../Modal';
import { isActionConfirmationModal } from '../../guards/isActionConfirmationModal';

export const Header = () => {
  const { modalData } = useModalWrapperContext();

  if (!isActionConfirmationModal(modalData)) {
    return null;
  }

  return <Modal.Header title={modalData['action-confirmation'].title} />;
};
